{
  "loading": "Chargement…",
  "error": "Impossible de charger les données.",
  "retry": "Réessayer",
  "empty": "Aucune donnée sur cette période.",
  "invalid": "Ce widget n’est pas configuré correctement.",
  "unknown": "Type de widget inconnu : {{type}}",
  "crashed": "Ce widget a rencontré une erreur.",
  "configure": "Configurer",
  "stale": "Données {{when}}",
  "staleNoData": "Source en retard",
  "offline": "Hors ligne",
  "sourceDown": "Source {{status}}",
  "fedBy": "Source : {{names}}",
  "status": {
    "active": "active",
    "degraded": "dégradée",
    "paused": "en pause",
    "error": "en erreur"
  },
  "fields": {
    "label": "Titre",
    "source": "Source",
    "sourcePlaceholder": "Choisir une source…",
    "metric": "Métrique",
    "metricPlaceholder": "Choisir une métrique…",
    "metricNone": "Cette source n’a encore écrit aucune métrique.",
    "tags": "Série",
    "tagsAll": "Toutes les séries",
    "range": "Période",
    "unit": "Unité",
    "unitNone": "Aucune",
    "decimals": "Décimales",
    "agg": "Agrégation",
    "rate": "Compteur : afficher le débit par seconde",
    "aggs": {
      "avg": "Moyenne",
      "min": "Minimum",
      "max": "Maximum",
      "last": "Dernière valeur"
    },
    "ranges": {
      "1h": "1 heure",
      "6h": "6 heures",
      "24h": "24 heures",
      "7d": "7 jours",
      "30d": "30 jours",
      "90d": "90 jours"
    }
  },
  "severity": {
    "info": "Info",
    "ok": "OK",
    "warn": "Attention",
    "error": "Erreur",
    "critical": "Critique"
  }
}
